import React, { useState, useEffect } from 'react';
import { Tooltip } from 'react-tooltip';
import { useParams, useNavigate } from "react-router-dom";
import { useForm } from 'react-hook-form';
import apiService from '../../Auth/apiService';
import DatosCabezaFamilia from '../Caracterizacion/DatosCabezaFamilia';
import { useMyContext } from '../../MyContext';
import { useAuth } from '../../Auth/AuthContext';
import SearchForm from '../Utils/Searchform';

export default function Registroalbergue(){
    const { token } = useAuth();
    const { future } = useMyContext();
    const navigate = useNavigate();
    const { idCabezaFamilia } = useParams();
    const { idPersona } = useParams();
    const [Cargando, setCargando] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
      });
    const [integrantes, setIntegrantes] = useState([]);
    const [formasalidas, setFormasalidas] = useState([]);
    const {register, handleSubmit, reset, watch} = useForm();
    const resetForm = (albergue, albergueNucleo) => {
        reset({
            ...albergue,
            ...albergueNucleo
        });
    };
    useEffect(() => {
        const fetchData = async () => {
            let url = '/albergue/crearformularioalbergue';
            let obj = {idCabezaFamilia: idCabezaFamilia, idPersona: idPersona};
            try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            setCabezaFamiliaDatos(result.cabezafamilia);
            setIntegrantes(result.integrantesdto);
            setFormasalidas(result.formasalidas);
            resetForm(result.albergue, result.alberguenucleo);
            } catch (error) {
            console.error('Error fetching data:', error);
            } finally {
            setCargando(false);
            }
        };

        fetchData();
    }, [idCabezaFamilia, idPersona, token]);
    
    const onSubmit = async (data) => {
        setCargando(true);
        let url = (data.id === 0)?'/caracterizacion/registroalbergue/guardar':'/caracterizacion/registroalbergue/actualizar';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar registro albergue', 'Registro guardado con exito');
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar registro albergue', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar registro albergue', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
        }
    };
    const handleSearch = (event) => {
        event.preventDefault();
        if (searchTerm.trim() !== '') {
            navigate(`/albergues/Registroalbergue/${searchTerm}/0`, { replace: true });
        }
    };
    // Nueva función para seleccionar/deseleccionar integrantes
    const seleccionar = (idPersona) => {
        if (idPersona.trim() !== '') {
            navigate(`/albergues/Registroalbergue/${idCabezaFamilia}/${idPersona}`, { replace: true });
        }
    };

    return (
        <div className="content-wrapper">
            <div hidden>Future: {future}</div>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Registro de albergue</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item active">Registro albergue</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <DatosCabezaFamilia datos={CabezaFamiliaDatos}></DatosCabezaFamilia>
                    <SearchForm searchTerm={searchTerm} setSearchTerm={setSearchTerm} handleSearch={handleSearch} Cargando={Cargando} />
                    
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">Integrantes</h3>
                        </div>
                        <div className="card-body">
                            <table className="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th>Seleccionar</th>
                                        <th>Nombre</th>
                                        <th>Documento</th>
                                        <th>Parentesco</th>
                                        <th>Estado vivanto</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {integrantes.map((integrante) => (
                                        <tr key={integrante.id}>
                                            <td>
                                                <button
                                                    type="button"
                                                    className={`btn btn-sm btn-info`}
                                                    onClick={() => seleccionar(integrante.per_idpersona)}
                                                >
                                                    {integrante.seleccionado ? 'Seleccionado' : 'Seleccionar'}
                                                </button>
                                            </td>
                                            <td>{integrante.nombre}</td>
                                            <td>{integrante.per_idpersona}</td>
                                            <td>{integrante.par_parentesco}</td>
                                            <td>{integrante.per_incluido}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    
                    
                    <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                        <div className='card'>
                            <div className="card-body">
                                <input hidden {...register('usrId')}/>
                                <input hidden {...register('cabIdcabezafamilia')}/><input hidden {...register('id')}/>
                                <input hidden {...register('albIdpersona')}/>
                                <h3>Aplica para cada persona del n&uacute;cleo</h3>
                                <div className='form-group row'>
                                    <label className="col-sm-2 col-form-label">Nombre</label>
                                    <div className="col-sm-4">
                                        {integrantes.find(integrante => integrante.per_idpersona === watch('albIdpersona'))?.nombre}
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label">Albergue</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register('albAlbergue')}
                                        />
                                    </div>
                                    
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label">Fecha Ingreso</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="date"
                                            className="form-control"
                                            {...register('albFechaingreso')}
                                        />
                                    </div>
                                    <label className="col-sm-2 col-form-label">Fecha Salida</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="date"
                                            className="form-control"
                                            {...register('albFechasalida')}
                                        />
                                    </div>
                                </div>
                                
                                <h3>Via Gubernativa (Aplica solo para la familia)</h3>

                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label">Forma Salida</label>
                                    <div className="col-sm-4">
                                        <select
                                            className="form-control"
                                            {...register('albFormasalidaid')}
                                            defaultValue=""
                                        >
                                            <option value="">Seleccione una opción</option>
                                            {formasalidas.map((fs) => (
                                                <option key={fs.id} value={fs.id}>
                                                    {fs.descripcion}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label">Fecha Declaraci&oacute;n</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="date"
                                            className="form-control"
                                            {...register('albFechadeclaracion')}
                                        />
                                    </div>

                                    <label className="col-sm-2 col-form-label">C&oacute;digo Declaración</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register('albCodigodeclaracion')}
                                        />
                                    </div>

                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label">Res. Valoraci&oacute;n</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="text"
                                            className="form-control"
                                            {...register('albResvalora')}
                                        />
                                    </div>
                                            
                                    <label className="col-sm-2 col-form-label">Fecha Notif. Resoluci&oacute;n</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="date"
                                            className="form-control"
                                            {...register('albFechanotificares')}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label">Fecha L&iacute;mite Resoluci&oacute;n</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="date"
                                            className="form-control"
                                            {...register('albFechaliminteres')}
                                        />
                                    </div>

                                    <label className="col-sm-2 col-form-label">Fecha Recurso Reposici&oacute;n Sub.</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="date"
                                            className="form-control"
                                            {...register('albFecharecursoreposub')}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label">Fecha L&iacute;mite Recurso</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="date"
                                            className="form-control"
                                            {...register('albFechalimiterecurso')}
                                        />
                                    </div>
                                    
                                    <label className="col-sm-2 col-form-label">Fecha Recurso Reposici&oacute;n</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="date"
                                            className="form-control"
                                            {...register('albFecharecursorepo')}
                                        />
                                    </div>
                                    
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label">Fecha Notif. Recurso</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="date"
                                            className="form-control"
                                            {...register('albFechanotirecurso')}
                                        />
                                    </div>
                                    
                                    <label className="col-sm-2 col-form-label">Resoluci&oacute;n Apelaci&oacute;n</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="date"
                                            className="form-control"
                                            {...register('albResoapelacion')}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label">Fecha Notif. Apelaci&oacute;n</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="date"
                                            className="form-control"
                                            {...register('albFechanotiapelacion')}
                                        />
                                    </div>

                                    <label className="col-sm-2 col-form-label">Fecha Tutela</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="date"
                                            className="form-control"
                                            {...register('albFechatutela')}
                                        />
                                    </div>
                                    
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label">Medida Preventiva</label>
                                    <div className="col-sm-4">
                                        <select
                                            className="form-control"
                                            {...register('albMedidapreventiva')}
                                            defaultValue=""
                                        >
                                            <option value="">Seleccione</option>
                                            <option value="SI">SI</option>
                                            <option value="NO">NO</option>
                                        </select>
                                    </div>

                                    <label className="col-sm-2 col-form-label">Fecha Impugnación</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="date"
                                            className="form-control"
                                            {...register('albFechaimpugnacion')}
                                        />
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label">Revocatoria</label>
                                    <div className="col-sm-4">
                                        <select
                                            className="form-control"
                                            {...register('albRevocatoria')}
                                            defaultValue=""
                                        >
                                            <option value="">Seleccione</option>
                                            <option value="SI">SI</option>
                                            <option value="NO">NO</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <button type="submit" className="btn btn-info">Guardar</button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}